import {ThemeProvider as MUIThemeProvider} from '@mui/material/styles';
import {theme} from './index.ts';

const ThemeProvider = props => (
  <MUIThemeProvider theme={theme} modeStorageKey="pl-mode" {...props} />
);

export default ThemeProvider;
